<script setup lang="ts">
  import { MpText } from '@borg/ui';

  defineProps<{
    title?: string;
    content?: string;
  }>();

  const hasSlot = computed(() => !!useSlots().default);
</script>

<template>
  <div class="job-section">
    <MpText
      v-if="title"
      class="job-section__title"
      as="h4"
    >
      {{ title }}
    </MpText>
    <MpText
      v-if="content"
      class="job-section__content"
      :no-margin="!hasSlot"
      as="div"
    >
      <WebView
        :html="content"
        :iframe="false"
      />
    </MpText>
    <div
      v-if="hasSlot"
      class="job-section__rows"
    >
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .job-section {
    & + .job-section {
      margin-top: var(--mp-space-90);
    }

    &__title {
      margin-bottom: var(--mp-space-50);
    }

    &__content {
      word-break: break-word;
    }

    &__rows {
      display: flex;
      flex-direction: column;
      gap: var(--mp-space-50);
    }
  }
</style>
